<template>
  <div>
    <el-dropdown
      size="small"
      class="d2-mr"
      placement="bottom"
      trigger="click"
      @visible-change="handleShowLogout"
    >
      <div class="userInfo">
        <img alt src="@/assets/main/user_icon.png" />

        <span :class="className">
          {{ info.realName ? info.realName : '未登录' }}
          <!-- <br />
          <font class="schoolName">{{ schoolName }}</font>-->
        </span>
        <template v-if="info.realName">
          <img
            src="@/assets/main/Icon_Arrow_Up.png"
            :style="{
              width: '10px',
              height: '10px',
              transform: showlogout ? '' : 'rotate(180deg)'
            }"
          />
        </template>
      </div>

      <el-dropdown-menu slot="dropdown">
        <!-- <el-dropdown-item @click.native="exchangeSchool">
          <d2-icon name="exchange" class="d2-mr-5" />切换学校
        </el-dropdown-item>-->
        <el-dropdown-item @click.native="logOff">
          <d2-icon name="power-off" class="d2-mr-5" />退出登录
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>

    <el-dialog
      title="切换学校"
      :visible.sync="dialogVisible"
      width="30%"
      :close-on-click-modal="false"
    >
      <div v-if="schoolList.length > 1" class="schoolListCon">
        <span class="selectClassLabel">选择学校:</span>
        <el-select
          :value="selectedSchoolValue"
          placeholder="请选择学校"
          size="medium"
          @change="changeHandler"
        >
          <el-option
            v-for="item in schoolList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" @click="dialogVisible = false">取 消</el-button>
        <el-button size="medium" type="primary" @click="confirmHandler">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import find from 'lodash/find';

export default {
  data() {
    return {
      dialogVisible: false,
      selected: undefined,
      showlogout: false
    };
  },
  computed: {
    ...mapState('d2admin/user', ['info']),
    ...mapState('ai/teacher', ['schoolList', 'selectedSchool']),
    className() {
      if (!(this.info.userType === '1' && this.info.analysisModule === '0')) {
        return 'btn-text';
      } else {
        return 'btn-texts';
      }
    },
    schoolName() {
      const target = find(this.schoolList, { id: this.selectedSchool });
      return target ? target.name : '未开通学校';
    },
    selectedSchoolValue() {
      return this.selected || this.selectedSchool;
    }
  },
  methods: {
    ...mapActions('d2admin/account', ['logout']),
    ...mapActions('d2admin/user', ['setUserType']),
    ...mapActions('ai/teacher', [
      'setSelectedSchool',
      'getClassListByUserIdAndSchoolId',
      'getSchedulesByClassId',
      'getAttendanceResult'
    ]),
    /**
     * @description 登出
     */
    logOff() {
      this.logout({
        confirm: true
      });
    },
    exchangeSchool() {
      this.dialogVisible = true;
    },
    changeHandler(val) {
      this.selected = val;
    },
    confirmHandler() {
      this.setSelectedSchool(this.selectedSchoolValue);
      // const target = find(this.schoolList, { id: this.selectedSchoolValue });
      // this.setUserType('2');
      this.dialogVisible = false;

      this.setSelectedSchool(this.selectedSchoolValue).then(() => {
        const routeName = this.$route.name;
        if (routeName === 'attendance') {
          this.getClassListByUserIdAndSchoolId().then(() => {
            this.getSchedulesByClassId().then(res => {
              // if (res.length > 0 || this.timeTab === 'week' || this.timeTab === 'month') {
              this.getAttendanceResult();
              // }
            });
          });
        }
      });
    },
    handleShowLogout(val) {
      this.showlogout = val;
    }
  }
};
</script>

<style lang="scss">
.btn-texts {
  padding: 14px 12px;
  border-radius: 4px;
  margin: 0px !important;
  color: #fff;
}

.schoolName {
  font-size: 12px;
  color: #999;
}
.userInfo {
  display: flex;
  align-items: center;
  img {
    width: 30px;
    height: 30px;
    // margin-top: 8px;
  }
}
.schoolListCon {
  margin: 0 36px;

  .selectClassLabel {
    font-size: 14px;
    margin-right: 16px;
  }

  .el-input__inner {
    width: 163px;
  }
}
</style>

<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/layout/header-aside/components/header-user/index.vue"
}
</vue-filename-injector>
